// extracted by mini-css-extract-plugin
export default {"moviedetailsContainer":"Moviedetails_moviedetailsContainer__DqErJ","image":"Moviedetails_image__vMUak","link":"Moviedetails_link__RsZ9W","category":"Moviedetails_category__s0ly+"};